<!-- Anzeige der Zielgruppe: Org-Nummern oder "Alle Nutzer" -->
{{ zielgruppe$$() }}
